const customerMenuForm = $('form.customer-menu-form');

customerMenuForm.on('submit', function (e) {
    e.preventDefault();

    let email = customerMenuForm.find('input[name="email"]').val();
    let password = customerMenuForm.find('input[name="password"]').val();
    let token = customerMenuForm.find('input[name="_token"]').val();
    let remember = customerMenuForm.find('input[name="remember"]').is(':checked');

    window.axios.post(window.config.urls.login, {
        email: email,
        password: password,
        remember: remember,
        _token: token
    }).then(({data: data}) => {
        if (data.hasOwnProperty('redirect')) {
            window.location.href = data.redirect;
        } else {
            window.location.reload();
        }
    }).catch((error) => {
        if (error.response.data.hasOwnProperty('redirect')) {
            window.location.href = error.response.data.redirect;
        } else {
            if (error.response.data.errors) {
                let url = new URL(window.config.urls.login);
                let message = '';
                $.each( error.response.data.errors, function ( i, val ) {
                    message = val;
                });
                url.searchParams.append('message', message);
                window.location.href = url.toString();
            }
        }
    });
});
